import { diContainer, serviceNames } from '../diContainer/diContainer';
import SaveNewBillingAddressUseCase from './SaveNewBillingAddressUseCase';
import SubmitNewsletterUseCase from './SubmitNewsletterUseCase';
import { ICourierTimesData } from '../domain/entities/Store/CourierStoresCollection';
import CourierStoresRepository from '../repositories/CourierStoresRepository';
import TransactionLoadHandler from './TransactionLoadHandler';
import UIState from '../stores/UIState';
import { NAVIGATION_ITEM_IDS } from '../constants/Constants';

class SubmitCourierUseCase extends TransactionLoadHandler {
  private courierStoresRepository: CourierStoresRepository;

  private timeData: ICourierTimesData;

  private doorId: string;

  private dropoffNotes: string;

  private uiState: UIState;

  constructor(
    timeData: ICourierTimesData,
    doorId: string,
    dropoffNotes: string,
  ) {
    super();
    this.courierStoresRepository = diContainer.get(serviceNames.courierStoresRepository);
    this.uiState = diContainer.get(serviceNames.uiState);
    this.timeData = timeData;
    this.doorId = doorId;
    this.dropoffNotes = dropoffNotes;
  }

  public async run(): Promise<void> {
    const transaction = await this.transactionRepository.getTransaction();
    const addressId = Number(transaction.shippingAddress.id);
    if (!Number(transaction.shippingAddress.id)) {
      throw new Error('No Shipping address provided.');
    }

    await this.courierStoresRepository.setCourier(
      this.doorId,
      addressId,
      this.dropoffNotes,
      this.timeData,
    );

    const { isAddressUndeliverable } = this.courierStoresRepository.courierStoresCollection;
    if (isAddressUndeliverable) {
      this.uiState.updateItemActiveState(NAVIGATION_ITEM_IDS.paymentId, false);
    }

    const saveNewBillingAddressUseCase = new SaveNewBillingAddressUseCase({
      transactionLoadOptions: {
        isEnabled: false,
      },
    });
    await saveNewBillingAddressUseCase.execute();

    const submitNewsletterUseCase = new SubmitNewsletterUseCase();
    await submitNewsletterUseCase.execute();
  }
}

export default SubmitCourierUseCase;
